import { MouseEvent, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import qs from 'qs'
import { getParamsValues } from '../../../utils/statementBannerUtils'

export default function TextInputWithButton() {
   const navigate = useNavigate()
   const location = useLocation()
   const paramValue = getParamsValues(location.search)
   const [value, setValue] = useState(paramValue.id || '')
   const handleClear = () => {
      setValue('')
      navigate(
         `?${qs.stringify(
            {},
            {
               allowDots: true,
               encode: false,
            },
         )}`,
      )
   }
   const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
      const request = Object.assign({}, { id: value })
      navigate(
         `?${qs.stringify(request, {
            allowDots: true,
            encode: false,
         })}`,
      )
   }
   return (
      <div className="flex items-center ">
         <div className="relative w-full">
            <input
               type="text"
               placeholder="ID socio"
               className="w-full border border-gray-300  py-2 px-4 pr-10 focus:outline-none "
               value={value}
               onChange={(e) => setValue(e.target.value)}
            />
            {value && (
               <button
                  onClick={handleClear}
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-red-500"
               >
                  X
               </button>
            )}
         </div>
         <button className="bg-blue-400 text-white px-4 py-2 rounded-tr-lg rounded-br-lg" onClick={handleClick}>
            buscar
         </button>
      </div>
   )
}
